import type { Activity } from "@/entities/activity";
import type { TagColor } from "@/ui/tag";

import { staticStates } from "@/constants/StaticStates";

export const getActivityEventColor = (activity: Activity): TagColor => {
  const state = staticStates.activity.find(({ key }) => key === activity.event);

  return state?.color ?? "default";
};

export const getActivityEventLabelKey = (activity: Activity) => {
  const { event, log_name } = activity;

  const useLogName = log_name === "import" || log_name === "batch";

  return useLogName ? `${log_name}.${event}` : event;
};
